<template>
  <div>
    <el-dialog custom-class="email-log-title-window" :close-on-click-modal="false" :visible.sync="innerVisible" width="544px" :title="$t('CargoMsg.Cargo_DownloadLog')" @close="innerVisible=false">
      <div class="app-main-inner-row row-grid">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          :style="{width:'505px',height:'350px'}"
        />
      </div></el-dialog>
  </div>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading } from '@/utils/utilBaseElement'
import { queryDownloadLog } from '@/api/clearing/invoice'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'

export default {
  name: 'DownloadLogWindow',
  props: {
    visible: { type: Boolean, required: true },
    fkUuid: { type: String, required: true }
  },
  data() {
    return {
      loading: false,
      innerVisible: false,
      gridOptions: {},
      gridParams: {},
      gridApi: {},
      columnDefs: [
        { headerName: this.$t('CargoMsg.Cargo_OperateTime'), field: 'dateCreated',
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }, width: 180
        },
        { headerName: this.$t('CargoMsg.Cargo_OperateBy'), field: 'createdBy', width: 120,
          cellRenderer: (params) => {
            const data = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
            return data
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_FileType'), field: 'fileType', width: 200 }
      ],
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: []
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.toQuery()
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.rowData = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.toQuery()
    }
  },
  mounted() {

  },
  methods: {
    toQuery() {
      if (!this.fkUuid) {
        return
      }
      this.loading = getLoading()
      queryDownloadLog({ 'fkUuid': this.fkUuid }).then(res => {
        this.rowData = res.data
      }).finally(() => {
        this.loading.close()
      })
    }
  }
}
</script>

<style lang="scss">
</style>
